import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import Home from './pages/Home/Home'
import DineInMenu from './pages/DineInMenu/DineInMenu';
import Privacy from './pages/PrivacyPolicy/Privacy';
import Navbar from 'components/Navbar';
import Footer from './components/Footer';
// import Test from './pages/Test/Test'

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="dine-in-menu" element={<DineInMenu />} />
        <Route path="privacy" element={<Privacy />} />
        {/* <Route path="test" element={<Test />} /> */}
      </Routes>
      <Footer />
      <Analytics />
    </Router>
  );
}

export default App;
